// import shopEstilosJson from '../config/shopEstilos.json';
import shopEstilosJson from '../config/paletas/paleta-azul.json';
import type { ShopEstilosConfig } from '../types/ShopEstilosConfig';

// Para probar otra paleta: cambiar el import de arriba por:
// import shopEstilosJson from '../config/paletas/paleta-azul.json';
// import shopEstilosJson from '../config/paletas/paleta-gris.json';
// import shopEstilosJson from '../config/paletas/paleta-dorado.json';
// Luego borrar el localStorage en DevTools → Application → Local Storage para forzar recarga.

export const HttpShopEstilos = {
  async obtenerEstilos(): Promise<ShopEstilosConfig> {
    // MOCK: lee del JSON local
    // TODO: reemplazar por GET /api/v1/tienda/estilos cuando el admin tenga la pantalla
    return shopEstilosJson as ShopEstilosConfig;
  },

  async obtenerBitModificados(): Promise<boolean> {
    // MOCK: siempre false — los estilos no cambian hasta que el admin los modifique
    // TODO: reemplazar por GET /api/v1/tienda/estilos/modificados
    return false;
  },
};
